import React, { useCallback } from 'react'
import moment, { Moment } from 'moment';

import ChevronIcon from './icons/ChevronIcon';
import { Form } from 'informed';
import TyDatePicker from '../../../components/inputs/TyDatePicker';
// import { ShiftFilterOptions } from './ShiftFilter'; // dočasně vypnuto (test výkonu kalendáře)
// import { useQuery } from 'react-query'; // dočasně vypnuto (test výkonu kalendáře)
// import apiClient from '../../../apiClient'; // dočasně vypnuto (test výkonu kalendáře)
import useSearchString from '../../../hooks/UrlParamsHandler/useSearchParams';
import { FavouriteIcon } from '@tymbe/ui-icons';
import classNames from 'classnames';
// import getResponseArray from '@tymbe/utils/getResponseArray'; // dočasně vypnuto (test výkonu kalendáře)

const DateHandlingBar = () => {
  const now = moment().startOf('week').toISOString();
  const [searchParams, setSearchParams] = useSearchString();
  const start = searchParams.get('start') ?? now;
  // dočasně vypnuto (test výkonu kalendáře) – sloužilo jen pro `filters` níže:
  // const companyId = Number(searchParams.get('company_id')) || undefined;
  // const branchofficeId = Number(searchParams.get('branchoffice_id')) || undefined;
  // const departmentId = Number(searchParams.get('department_id')) || undefined;
  // const shiftFilter = searchParams.get('shiftFilter') || undefined;
  // const templates = searchParams.get('templates')?.split(',').map(Number) || [];

  const getMonthTitle = (s: string, e?: string) => {
    const startDate = moment(s);
    const endDate = e ? moment(e) : startDate;
    return startDate.get('month') === endDate.get('month')
      ? startDate.format('[]MMMM')
      : `${startDate.format('MMM')} - ${endDate.format('MMM')}`;
  };

  // dočasně vypnuto (test výkonu kalendáře):
  // const filters = {
  //   templates,
  //   companyId,
  //   branchofficeId,
  //   departmentId,
  //   shiftFilter,
  // };

  /* --- DOČASNĚ VYPNUTO (test výkonu kalendáře) ---------------------------------
   * Navigace na nejbližší týden s nepotvrzenou docházkou (before/after dotaz +
   * červené tečky) generovala pomalý 2měsíční / celofiremní dotaz, který držel
   * spinner i po načtení dat mřížky. Vypnuto ve všech kombinacích filtrů.
   * Při zapínání zpět doporučeno přidat react-query `enabled: !!companyId`.
   *
  const { data: shiftDatesWithoutAttendance } = useQuery(['unresolved', 'calendar', filters, start], async (): Promise<any> => {
    const modifiers: Record<string, boolean> = {unconfirmedAttendance: true};
    const weekStart = moment(start);
    const weekEnd = moment(start).add(7, 'day').endOf('day');
    if (filters.shiftFilter === ShiftFilterOptions.NOT_FULL) modifiers.unFilledOnly = true;

    const query = {
      'shift.company_id': filters.companyId,
      parent_id: filters.branchofficeId,
      branchoffice_id: filters.departmentId,
      $limit: 1,
      $paginate: false,
      $modify: modifiers,
      $joinRelation: 'branchoffice',
      shift_template_id: {},
    };
    if (filters.templates?.length) {
      query.shift_template_id = { $in: filters.templates };
    }

    const after = getResponseArray(await apiClient.service('shift').find({
      query: {
        ...query,
        $and: [
          {
            start_time: { $gt: weekEnd.toISOString() }
          },
          {
            start_time: { $lt: now }
          }
        ],
        $sort: { start_time: 1 },
      },
    }));
    const before = getResponseArray(await apiClient.service('shift').find({
      query: {
        ...query,
        $and: [
          {
            start_time: { $lt: weekStart.toISOString() },
          },
          {
            start_time: { $gt: weekStart.clone().subtract(2, 'month').toISOString() }
          }
        ],
        $sort: { start_time: -1 }
      }
    }));
    return [before[0], after[0]];
  }, { staleTime: 1000 * 5});

  const firstShiftWithUnconfirmedAttendanceBeforeThisWeek = shiftDatesWithoutAttendance?.[0];
  const firstWithUnconfirmedAttendancePresentAfterThisWeek = shiftDatesWithoutAttendance?.[1];

  const handlePrevUnconfirmedAttendance = useCallback(() => {
    const newStart = moment(firstShiftWithUnconfirmedAttendanceBeforeThisWeek?.start_time).startOf('week').toISOString();
    const newParams = new URLSearchParams(searchParams);
    if (newStart === now) {
      newParams.delete('start');
    } else {
      newParams.set('start', newStart);
    }
    setSearchParams(newParams);
  }, [now, searchParams, setSearchParams, firstShiftWithUnconfirmedAttendanceBeforeThisWeek]);

  const handleNextUnconfirmedAttendance = useCallback(() => {
    const newStart = moment(firstWithUnconfirmedAttendancePresentAfterThisWeek?.start_time).startOf('week').toISOString();
    const newParams = new URLSearchParams(searchParams);
    if (newStart === now) {
      newParams.delete('start');
    } else {
      newParams.set('start', newStart);
    }
    setSearchParams(newParams);
  }, [now, searchParams, setSearchParams, firstWithUnconfirmedAttendancePresentAfterThisWeek]);
  */

  const handlePrevWeek = useCallback(() => {
    const newStart = moment(start).subtract(1, 'week').toISOString();
    const newParams = new URLSearchParams(searchParams);
    if (newStart === now) {
      newParams.delete('start');
    } else {
      newParams.set('start', newStart);
    }
    setSearchParams(newParams);
  }, [now, searchParams, setSearchParams, start]);

  const handleNextWeek = useCallback(() => {
    const newStart = moment(start).add(1, 'week').toISOString();
    const newParams = new URLSearchParams(searchParams);
    if (newStart === now) {
      newParams.delete('start');
    } else {
      newParams.set('start', newStart);
    }
    setSearchParams(newParams);
  }, [now, searchParams, setSearchParams, start]);

  const setWeek = useCallback((date: Moment) => {
    const newStart = date.startOf('week').toISOString();
    const newParams = new URLSearchParams(searchParams);
    if (newStart === now) {
      newParams.delete('start');
    } else {
      newParams.set('start', newStart);
    }
    setSearchParams(newParams);
  }, [now, searchParams, setSearchParams]);

  return (
    <div className='flex gap-3 bg-white h-10'>
      <div className="capitalize shadow-down-xs flex rounded-lg border border-secondary-100 w-fit">
        <div className='relative'>
          <button
            className={classNames("relative flex p-1 justify-center items-center size-10 rounded-none",
              "border-r border-secondary-100 hover:bg-secondary-50"
            )}
            type="button"
            onClick={handlePrevWeek}>
              <ChevronIcon className='-scale-x-100' />
          </button>
          {/* dočasně vypnuto (test výkonu kalendáře):
          {firstShiftWithUnconfirmedAttendanceBeforeThisWeek &&
            <FavouriteIcon name="error" className='size-4 absolute -top-1 -left-1 text-red-500' onClick={handlePrevUnconfirmedAttendance} />
          }
          */}
        </div>
          <Form
            onChange={({ values }) => {
              if (values.date) setWeek(values.date);
            }}
            className='flex items-center w-52 hover:bg-secondary-50'
          >
            <TyDatePicker
            className='h-full w-full flex items-center cursor-pointer'
              highlightHolidays
              name="date"
              datePresets={[
                {
                  label: 'Tento týden',
                  date: moment().startOf('week').toISOString(),
                },
              ]}
              defaultValue={moment(start)}
              // there is no easy way to extract input render

              inputRender={(props) => (
                <label className="text-body-2-xl font-semibold text-secondary-600 flex gap-2.5 px-3 items-center cursor-pointer">
                  <FavouriteIcon name="calendar_today" className='size-4' />
                  {getMonthTitle(
                    start,
                    moment(start).add(7, 'day').toISOString(),
                  )}
                  {moment(start).format(' YYYY')}
                  <input hidden {...props} />
                </label>
              )}
            />
          </Form>
          <div className='relative'>
            <button
              className={classNames("relative flex p-1 justify-center items-center size-10",
                "rounded-none border-l border-secondary-100 hover:bg-secondary-50"
              )}
              type="button"
              onClick={handleNextWeek}>
              <ChevronIcon />
            </button>
            {/* dočasně vypnuto (test výkonu kalendáře):
            {firstWithUnconfirmedAttendancePresentAfterThisWeek &&
              <FavouriteIcon name="error" className='size-4 absolute -top-1 -right-1 text-red-500' onClick={handleNextUnconfirmedAttendance} />
            }
            */}
          </div>
        </div>
        <button
          onClick={() => setWeek(moment().startOf('week'))}
          type='button'
          className={classNames("text-body-2-xl font-semibold flex shadow-down-xs rounded-lg",
          "border border-secondary-100 items-center justify-center px-3 hover:bg-secondary-50"
          )}>
            Dnes
        </button>
      </div>
  )
}

export default DateHandlingBar
